export async function audioPlay(fileUrl) {
    const audio = new Audio(fileUrl);
    await audio.play().catch((e) => {
        console.error(e);
    });
}
